export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_19.74eb5c76.jpg";